export default __webpack_public_path__ + "static/media/scorpio.818fa9c0.png";